import '.d{display:flex;}.ssr-plugin'
import '.a9{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.z{cursor:pointer;}.ssr-plugin'
import '.fj{padding:0.75rem;}.ssr-plugin'
import '.aj{border-radius:1.25rem;}.ssr-plugin'
import '.u{border:var(--border-subtle);}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.da{transition:background-color 0.2s ease;}.ssr-plugin'
import '.fk{width:2.5rem;}.ssr-plugin'
import '.dt{height:2.5rem;}.ssr-plugin'
import '.fl{color:var(--palette-blue-700);}.ssr-plugin'
import '.fm{font-size:0.9rem;}.ssr-plugin'
import '.a3{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="d a9 e r s z fj aj u t da"
        style={{
          '&:hover': {
            backgroundColor: 'var(--palette-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="fk dt d r a9 fl"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="fm fl a3"
        >
          {label}
        </span>
      </styled.button>
    )
}